module.exports = __webpack_public_path__ + "img/bg-image-document-a34c6971.png";